import { Component } from "react";
import BanqueService from "../services/Banque";
import makeAnimated from "react-select/animated";
import Select from "react-select";
import BankService from "../services/PosService/BankService";
import getCurrentUserId from "../reduxSaga/sagas/requests/currentUserId";
class ListBanquesToPayement extends Component {
  state = {
    banqueAccountNumber: "",
    banquesAccount: [],
    selectedOption: null,
    options: [],

    // agenceName: "",
    // agences: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      banqueAccount: "",
      banquesAccount: [],
      selectedOption: null,
      options: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (selectedOption) => {
    this.setState({ selectedOption }, () =>
      console.log(`Option selected:`, this.state.selectedOption)
    );
    localStorage.setItem("banqueAccount", selectedOption.value);
    localStorage.setItem("banqueAccountName", selectedOption.customElements.name);
    localStorage.setItem("banqueAccountRIB", selectedOption.customElements.rib);

  };

  componentDidMount() {
    this.forceUpdate();
    if (localStorage.getItem("status").includes("ADMIN")) {
      BanqueService.getAllBankAccounts(this.props.type)
        .then((response) => {
          if (response.data["Banque"]) {
            this.setState({ alert_message: "error" });
          } else {
            this.setState({ banquesAccount: response.data["success"] });

            this.setState({ alert_message: "success" });
            this.remplissageOptions();
          }
        })
        .catch((error) => {
          this.setState({ alert_message: "error" });

          this.setState({ alert_message: "success" });
        });
    } else if (localStorage.getItem("status").includes("DIRECTEUR_MAGASIN")) {
      BankService.getAllBankAccountsByManager(getCurrentUserId())
        .then((response) => {
          if (response.data.success) {
            this.setState({ banquesAccount: response.data.success });
             this.remplissageOptions();
          } else if (response.data.error) {
            this.setState({ alert_message: "error" });

            console.log("error : " + response.data.error);
          }
        })
        .catch((e) => {
          this.setState({ alert_message: "error" });

          console.log("Erreur : ", e);
        })

    }
  }
  remplissageOptions() {
    console.log(this.state.banquesAccount);
    this.state.banquesAccount.map((BA) =>
      this.setState({
        options: [
          ...this.state.options,
          {
            value: BA.idBankAccount,
            // ribOnly: show only the RIB of the account / cash register
            label: this.props.ribOnly
              ? BA.rib
              : BA.rib + "-" + BA.name + "-" + BA.agenceLocalisation,
            customElements:{
              rib:BA.rib,
              name:BA.name

            }
          },
        ],
      })
    );
  }


  render() {
    const animatedComponents = makeAnimated();

    const { selectedOption } = this.state;
    return (
      <div>
        <div class="row">
          <div class="col-12">
          
            <div>
              <Select
                value={this.state.selectedOption}
                closeMenuOnSelect={true}
                components={animatedComponents}
                options={this.state.options}
                onChange={this.handleChange}
                defaultValue={selectedOption}
                placeholder={""}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ListBanquesToPayement;
